import { FormControl, FormLabel, TextField, Typography } from '@mui/material';
import { ControllerRenderProps, FieldError } from 'react-hook-form';

interface PasswordFieldProps {
  label: string;
  disabled: boolean;
  value: string;
  onChange: ControllerRenderProps['onChange'];
  error?: FieldError;
  name: string;
  readOnly: boolean;
}

export const PasswordField = ({ label, disabled, value, onChange, error, name, readOnly }: PasswordFieldProps) => {
  return (
    <>
      <FormControl fullWidth size="small" data-cy-field-type="password">
        <FormLabel id={`${name}-label`}>{label}</FormLabel>
        <TextField
          size="small"
          type="password"
          aria-labelledby={`${name}-label`}
          value={value}
          error={!!error}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          inputProps={{ readOnly }}
        />
      </FormControl>
      {error ? <Typography color="error">{error!.message as string}</Typography> : <br />}
    </>
  );
};

export default PasswordField;
